import {
  getPhoenixTraderSubaccountAddress,
  resolvePhoenixInstructionAddresses,
  type Authority,
} from "@ellipsis-labs/rise";

import { getPhoenixEnv } from "@/lib/env";

/**
 * Resolves the Phoenix instruction address set for the active PHOENIX_ENV.
 * This is the single source of truth for the Phoenix program address across
 * all code paths that construct instructions or derive PDAs.
 */
export const resolvePhoenixAddressesForEnv = () =>
  resolvePhoenixInstructionAddresses({ phoenixEnv: getPhoenixEnv() });

export const getPhoenixTraderSubaccountAddressForEnv = ({
  authority,
  traderPdaIndex,
  subaccountIndex,
}: {
  authority: Authority;
  traderPdaIndex: number;
  subaccountIndex: number;
}) => {
  const phoenixAddresses = resolvePhoenixAddressesForEnv();

  return getPhoenixTraderSubaccountAddress({
    authority,
    traderPdaIndex,
    subaccountIndex,
    phoenixProgramAddress: phoenixAddresses.programAddress,
  });
};
